module.exports = __webpack_public_path__ + "static/media/22ESCWA24.17b78079.jpg";